import { Field } from "react-final-form"

import { CheckboxControl } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

const ShippingAddressControl = ({ scrollToTarget }) => (
  <Field
    name="isShippingAddressSameAsBillingAddress"
    type="checkbox"
    component={CheckboxControl}
    parse={(value) => {
      if (value) {
        return true
      }

      setTimeout(scrollToTarget, 0)

      return false
    }}
    sx={{
      my: 2,
      "& input ~ div": {
        borderRadius: 4,
        borderColor: "textLight",
        boxShadow: "none",
      },
    }}
  >
    <Trans i18nKey="Start.Shipping.sameAddressCheckboxLabel" />
  </Field>
)

export default ShippingAddressControl
